import { render } from "./AtividadesV2Embed.vue?vue&type=template&id=4779e5ec&scoped=true"
import script from "./AtividadesV2Embed.vue?vue&type=script&lang=js"
export * from "./AtividadesV2Embed.vue?vue&type=script&lang=js"

import "./AtividadesV2Embed.vue?vue&type=style&index=0&id=4779e5ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4779e5ec"]])

export default __exports__